import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M9.85 3.664a.75.75 0 0 1 .19.73 7.75 7.75 0 0 0 9.58 9.562.75.75 0 0 1 .928.917c-1.065 3.967-4.686 6.888-8.99 6.888a9.31 9.31 0 0 1-9.308-9.308c0-4.298 2.913-7.915 6.871-8.986a.75.75 0 0 1 .73.197M8.322 5.345a7.81 7.81 0 0 0 3.236 14.916 7.81 7.81 0 0 0 7.114-4.584A9.25 9.25 0 0 1 8.322 5.345"
      clipRule="evenodd"
    />
    <path d="M19.829 7.25a.75.75 0 0 1 .75.75v1.078h1.078a.75.75 0 0 1 0 1.5h-1.079v1.08a.75.75 0 0 1-1.5 0v-1.08H18a.75.75 0 0 1 0-1.5h1.078V8a.75.75 0 0 1 .75-.75M13.414 4.25a.75.75 0 0 1 .75.75v.664h.664a.75.75 0 0 1 0 1.5h-.664v.665a.75.75 0 0 1-1.5 0v-.665H12a.75.75 0 0 1 0-1.5h.664V5a.75.75 0 0 1 .75-.75" />
  </>
);

const Weather31 = Icon('weather-31', svgContents);

export default Weather31;
